import { render, staticRenderFns } from "./AccordionItemToggleIcon.vue?vue&type=template&id=3e8a414f&scoped=true&"
import script from "./AccordionItemToggleIcon.vue?vue&type=script&lang=ts&"
export * from "./AccordionItemToggleIcon.vue?vue&type=script&lang=ts&"
import style0 from "./AccordionItemToggleIcon.vue?vue&type=style&index=0&id=3e8a414f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e8a414f",
  null
  
)

export default component.exports